module.exports = __webpack_public_path__ + "static/media/thumbnail_paragard-information.3efc5de1.jpg";